<div class="bundle-type-dialog" data-cy="bundleTypeDialog">
  <div class="radio-option-list">
    @for (option of options; track option.value) {
      <div class="option">
        <p-radiobutton
          [inputId]="option.value"
          [value]="option.value"
          [(ngModel)]="selected"
          [attr.data-cy]="'bundleTypeOption-' + option.value"
        />
        <label [for]="option.value">
          <strong>{{ option.titleKey | transloco }}</strong>
          <span>{{ option.descriptionKey | transloco }}</span>
          <span class="usage">{{ option.usageKey | transloco }}</span>
        </label>
      </div>
    }
  </div>
  <p class="note">{{ 'GROUP_SESSION_EDITOR.CHOOSE_TYPE_MESSAGE' | transloco }}</p>
  <div class="actions-footer-row">
    <p-button
      [label]="'COMMON.CANCEL' | transloco"
      [outlined]="true"
      severity="secondary"
      (onClick)="cancel()"
      data-cy="bundleTypeCancel"
    />
    <p-button [label]="'COMMON.CONFIRM' | transloco" (onClick)="confirm()" data-cy="bundleTypeConfirm" />
  </div>
</div>
